import {ICountry} from "./intra-country-ban-my-suffix.model";
import { PolicyMarketType } from "./policy-my-suffix.model";

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}
 export enum Carriage {
    PRE = 'PRE',
    POST = 'POST'

}
export enum Shipping {
    DOMESTIC = 'DOMESTIC',
    INTERNATIONAL = 'INTERNATIONAL'

} 
export enum ShippingPlaceLimit {
    WITHIN_PORT_SURROUNDING = 'WITHIN_PORT_SURROUNDING',
    ALL_PLACES_WITHIN_THE_TRANSPORTED_FROM_COUNTRY = 'ALL_PLACES_WITHIN_THE_TRANSPORTED_FROM_COUNTRY',
    ALL_PLACES_WITHIN_THE_TRANSPORTED_TO_COUNTRY = 'ALL_PLACES_WITHIN_THE_TRANSPORTED_TO_COUNTRY',
    ALL_PLACES_WITHIN_THE_COUNTRY = 'ALL_PLACES_WITHIN_THE_COUNTRY' ,
    KM_LIMITATIONS = 'KM_LIMITATIONS'
}

export interface ISubRuleMySuffix {
    id?: number;
    activeStatus?: ActiveStatus;
    carriage?: Carriage;
    countryList?: ICountry[];
    shipping?: Shipping;
    transportedFromToList?: ICountry[];
    placeLimit?: ShippingPlaceLimit;
    kmLimit?: number;
    premiumRate?: number;
    ruleId?: number;
    policyMarketType?: PolicyMarketType;
	
}

export class SubRuleMySuffix implements ISubRuleMySuffix {
    constructor(
        public id?: number,
        public activeStatus?: ActiveStatus,
        public carriage?: Carriage,
        public countries?: ICountry[],
        public shipping?: Shipping,
        public transportedFromToList?: ICountry[],
        public placeLimit?: ShippingPlaceLimit,
        public kmLimit?: number,
        public premiumRate?: number,
        public ruleId?: number,
        public policyMarketType?: PolicyMarketType

        ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.countries = [];
        this.transportedFromToList=[];
        this.premiumRate=0;
    }

}
